import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=67a549b8&"
import script from "./Questionnaire.vue?vue&type=script&lang=ts&"
export * from "./Questionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=67a549b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports